export enum FileHubFileEnum {
  CONFIDENTIAL = "Confidential",
  REGULAR = "Regular",
}

export interface GetFileHubFilesPaginatedResult {
  subscription: boolean;
  count: number;
  previousPage: string;
  nextPage: string;
  rows: GetFileHubFilesResult[];
}

export interface GetFileHubFilesResult {
  FileHubUid: string;
  fileName: string;
  size: string;
  type: FileHubFileEnum;
  user: string;
  dateCreated: string;
}

export interface FileHubFilesQueryParams {
  search?: string;
  type?: FileHubFileEnum;
  dateFrom?: string;
  dateTo?: string;
  limit?: number;
  offset?: number;
  orderBy?: string;
  sort?: "asc" | "desc";
}

export interface FileHubDeleteResponseStatus {
  status: "OK" | "WARNING";
  countNotAllowed: number;
  countDeleted: number;
  notAllowedFileHubs: [
    {
      name: string;
      user: string;
    },
  ];
}

export interface FileHubCreateUpdateBody {
  FileHubUid?: string;
  url: string;
  size: string;
  type: FileHubFileEnum;
}

export interface FileHubCreateUpdateResult {
  FileHubUid: string;
}

export interface FileHubByIdResult {
  FileHubUid: string;
  name: string;
  size: string;
  portalUid: string;
  type: FileHubFileEnum;
  url?: string;
  path?: string;
}

export interface GetS3PresignedUrlsDownloadResult {
  fileName: string;
  path: string;
  downloadUrl: string;
}

export interface GetS3PresignedUrlsDownloadResponse {
  files: GetS3PresignedUrlsDownloadResult[];
  notFound: string[];
}
